import { gameplayVictoryConditions, gamePieceColors, gamePieceTypes } from "../../enums/enums";
import GamePieceComponent from "../gameplay/GamePiece/GamePieceComponent";

export const lvl1PeridotVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
    board1State: [
        /*[
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem2, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
        ],
        [
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem2, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
        ],
        [
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem2, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.gem, 0),
        ],*/           
         
        [
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.star, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),            
        ],
        [
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.gem3, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),
            new GamePieceComponent(gamePieceColors.none, gamePieceTypes.none, 0),            
        ],
    ],
    board2State: [
        [
            new GamePieceComponent(gamePieceColors.gem2, gamePieceTypes.gem, 0),
            new GamePieceComponent(gamePieceColors.gem3, gamePieceTypes.trash, 10),
            new GamePieceComponent(gamePieceColors.gem3, gamePieceTypes.trash, 5),
            new GamePieceComponent(gamePieceColors.gem4, gamePieceTypes.trash, 5),
            new GamePieceComponent(gamePieceColors.gem4, gamePieceTypes.trash, 5),
            new GamePieceComponent(gamePieceColors.gem1, gamePieceTypes.star, 0),
        ],
    ]
}

export const lvl2PeridotVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl3PeridotVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl4PeridotVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl5PeridotVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl1JasperVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl2JasperVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl3JasperVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl4JasperVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}

export const lvl5JasperVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}


export const lvl1Y_DiamondVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}
export const lvl2Y_DiamondVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}
export const lvl3Y_DiamondVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}
export const lvl4Y_DiamondVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}
export const lvl5Y_DiamondVictoryParams =
{
    condition: gameplayVictoryConditions.normalVictory,
    timer: 0,
    chainsToMake: 0,
    trashToSurvive: 0,
}